import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import ShopSupplierList from "../../components/Shops/Suppliers";

const ShopSupplierPage = (): ReactElement => {
  return (
    <Layout>
      <ShopSupplierList />
    </Layout>
  );
};

export default ShopSupplierPage;
